module.exports = __webpack_public_path__ + "img/soft_3.31bd614e.png";